import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { DebatesService } from 'core/index';
@Component({
  selector: 'lms-debates-list',
  templateUrl: './debates-list.component.html',
  styleUrls: ['./debates-list.component.scss']
})
export class DebatesListComponent implements OnInit, OnChanges {
  @Input() listId: string;
  @Input() options: any;
  public listOptions: any;

  public debates: any[];

  constructor(public debatesService: DebatesService) {}

  ngOnInit() {}

  ngOnChanges() {
    this.listOptions = Object.assign({}, this.options);
  }

  setCollection(collection) {
    if (collection) {
      this.debates = collection;
    }
  }
}
